<template>
    <section id="home" class="section welcome-area">
        <div class="container hero-container">
            <div class="row hero-row">
                <div class="col-12 col-md-6 col-lg-6 hero-copy-col">
                    <div class="welcome-intro">
                        <span class="eyebrow">{{ $t('hero.eyebrow') }}</span>
                        <h2 v-html="$t('common.slogan')"></h2>
                        <p class="my-3">{{ $t('hero.homeIntro') }}</p>
                        <div class="button-group">
                            <a :href="iosDownloadUrl" target="_blank">
                                <img src="assets/img/ios_download.svg" :alt="$t('hero.appStoreAlt')">
                            </a>
                            <a :href="androidDownloadUrl" target="_blank">
                                <img src="assets/img/google_play_download.svg" :alt="$t('hero.googlePlayAlt')">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 mt-5 mt-md-0 hero-visual-col">
                    <div class="hero-visual" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                        <div class="hero-bg hero-bg-left" aria-hidden="true">
                            <img src="assets/img/hero/expenses-background-neutral.png" alt="">
                        </div>
                        <div class="hero-bg hero-bg-right" aria-hidden="true">
                            <img src="assets/img/hero/chart-background-neutral.png" alt="">
                        </div>
                        <div class="welcome-thumb" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                            <div class="home-dashboard" data-aos="zoom-in">
                                <img src="assets/img/hero/home-dashboard.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        iosDownloadUrl() {
            return process.env.VUE_APP_IOS_DOWNLOAD_URL;
        },
        androidDownloadUrl() {
            return process.env.VUE_APP_ANDROID_DOWNLOAD_URL;
        }
    }
}
</script>

<style scoped>
    .welcome-area {
        background:
            radial-gradient(circle 350px at 86.1% 22.2%, rgba(37, 99, 235, 0.18) 0, rgba(37, 99, 235, 0.08) 52%, rgba(37, 99, 235, 0) 100%),
            linear-gradient(105deg, rgba(248, 250, 255, 0) 43%, rgba(37, 99, 235, 0.09) 100%),
            radial-gradient(circle 190px at 7.64% 87.8%, rgba(132, 212, 238, 0.13) 0, rgba(132, 212, 238, 0) 100%),
            #f8faff;
        height: 900px;
        min-height: 900px;
        overflow: hidden;
        padding: 0;
    }
    .hero-container {
        height: 100%;
        max-width: 1440px;
        padding: 0;
        position: relative;
    }
    .hero-row {
        height: 100%;
        margin: 0;
        position: relative;
    }
    .hero-copy-col,
    .hero-visual-col {
        flex: none;
        max-width: none;
        padding: 0;
        position: absolute;
    }
    .hero-copy-col {
        left: 4.1667%;
        top: 29.7222%;
        width: 58%;
    }
    .hero-visual-col {
        left: 55.7291%;
        margin-top: 0 !important;
        top: 20.4444%;
        width: 38.7154%;
    }
    .welcome-intro {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: 22px;
        width: 100%;
    }
    .eyebrow {
        color: #1d4ed8;
        display: inline-block;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.8px;
        line-height: 19.2px;
        margin: 0;
        padding: 5.5px 16px 5.69px 10px;
        text-transform: uppercase;
    }
    .welcome-intro h2 {
        box-sizing: border-box;
        color: #002b7f;
        font-size: clamp(62px, 5.1389vw, 70px);
        font-weight: 600;
        letter-spacing: -2px;
        line-height: 1.08;
        margin: 0;
        max-width: 800px;
        padding: 4.955px 0 0.855px;
        width: 100%;
    }
    .welcome-intro h2 ::v-deep b {
        color: #2563eb;
        font-weight: 600;
    }
    .welcome-intro p {
        color: #090909;
        font-size: 18px;
        font-weight: 300;
        line-height: 1.5;
        margin: 0 !important;
        max-width: 546px;
        width: 100%;
    }
    .button-group {
        display: flex;
        gap: 22px;
        margin: 0;
    }
    .button-group a {
        display: block;
        height: 48px;
        margin-right: 0;
        width: 144px;
    }
    .button-group img {
        display: block;
        height: 48px;
        width: 144px;
    }
    .hero-visual {
        aspect-ratio: 557.5 / 564.6;
        margin: 0 auto;
        max-width: 557.5px;
        position: relative;
        width: 100%;
    }
    .hero-bg {
        height: auto;
        mix-blend-mode: multiply;
        opacity: 0.88;
        position: absolute;
        top: 6.23%;
        width: 45.56%;
    }
    .hero-bg img {
        display: block;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
    .hero-bg-left {
        aspect-ratio: 254 / 494;
        left: -4.39%;
    }
    .hero-bg-right {
        aspect-ratio: 254 / 491;
        right: -4.39%;
    }
    .welcome-thumb {
        aspect-ratio: 308 / 611;
        left: 23.27%;
        margin: 0;
        max-width: none;
        padding: 0;
        position: absolute;
        top: -3.19%;
        width: 55.25%;
        z-index: 2;
    }
    .home-dashboard {
        height: 100%;
        width: 100%;
    }
    .home-dashboard img {
        display: block;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }

    @media (max-width: 1199px) {
        .welcome-area {
            height: auto;
            min-height: 760px;
            padding: 130px 0 80px;
        }
        .hero-container {
            height: auto;
            max-width: 1140px;
            padding: 0 30px;
        }
        .hero-row {
            align-items: center;
            display: flex;
            height: auto;
            margin: 0 -15px;
        }
        .hero-copy-col,
        .hero-visual-col {
            left: auto;
            padding: 0 15px;
            position: relative;
            top: auto;
        }
        .hero-copy-col {
            max-width: 60%;
            width: 60%;
        }
        .hero-visual-col {
            max-width: 40%;
            width: 40%;
        }
        .welcome-intro {
            gap: 18px;
        }
        .welcome-intro h2 {
            font-size: 56px;
            letter-spacing: -1.5px;
        }
    }

    @media (max-width: 767px) {
        .welcome-area {
            min-height: auto;
            padding: 70px 0 60px;
            text-align: center;
        }
        .hero-container {
            padding: 0 15px;
        }
        .hero-row {
            display: block;
            margin: 0;
        }
        .hero-copy-col,
        .hero-visual-col {
            max-width: 100%;
            padding: 0;
            width: 100%;
        }
        .hero-visual-col {
            margin-top: 48px !important;
        }
        .welcome-intro {
            align-items: center;
            gap: 18px;
        }
        .welcome-intro h2,
        .welcome-intro p {
            margin-left: auto;
            margin-right: auto;
        }
        .welcome-intro h2 {
            font-size: 38px;
            letter-spacing: -1px;
            line-height: 1.08;
        }
        .welcome-intro p {
            font-size: 16px;
            max-width: 520px;
        }
        .button-group {
            gap: 12px;
        }
        .button-group a,
        .button-group img {
            height: 40px;
            width: 120px;
        }
    }

</style>
